module.exports = __webpack_public_path__ + "img/entry_level-image.78630727.png";